const routes = [
  {
    name: 'signin',
    path: '/',
    component: () => import('../pages/Index.vue'),
    children: [],
  },
  {
    path: '/student',
    component: () => import('../layouts/MainLayout.vue'),
    children: [
      {
        name: 'subscription-management',
        path: 'subscription',
        component: () => import('../pages/Subscription.vue'),
      },
      {
        name: 'student-my-page',
        path: 'me',
        component: () => import('../pages/student/MyPage.vue'),
      }, 
      // SSR Matching は現在利用していないため、ナビ非表示に加えルートも無効化する。
      // （直URLアクセスもできないように定義ごとコメントアウト。再利用時はコメントを外す）
      // {
      //   name: 'ssr-matching',
      //   path: 'ssr-matching',
      //   component: () => import('../pages/student/SsrMatching.vue'),
      // },

      // ===== LMS（生徒導線） =====
      {
        name: 'student-lms-courses',
        path: 'lms/courses',
        component: () => import('../pages/student/lms/Courses.vue'),
      },
      {
        name: 'student-lms-course',
        path: 'lms/courses/:courseId',
        component: () => import('../pages/student/lms/CourseDetail.vue'),
      },
      {
        name: 'student-lms-lesson',
        path: 'lms/courses/:courseId/lessons/:lessonId',
        component: () => import('../pages/student/lms/Lesson.vue'),
      },
      {
        name: 'student-lms-quiz',
        path: 'lms/quizzes/:quizId',
        component: () => import('../pages/student/lms/Quiz.vue'),
      },
      {
        name: 'student-lms-grades',
        path: 'lms/grades',
        component: () => import('../pages/student/lms/Grades.vue'),
      },
      {
        name: 'student-lms-feedback',
        path: 'lms/feedback',
        component: () => import('../pages/student/lms/Feedback.vue'),
      },
      {
        name: 'student-lms-manual',
        path: 'lms/manual',
        component: () => import('../pages/student/lms/Manual.vue'),
      },
    ],
  },
  {
    path: '/admin',
    component: () => import('../layouts/AdminLayout.vue'),
    children: [
      {
        name: 'admin-student-management',
        path: 'students',
        component: () => import('../pages/admin/ListStudent.vue'),
      },
      {
        name: 'admin-teacher-management',
        path: 'teachers',
        component: () => import('../pages/admin/ListTeacher.vue'),
      },
      {
        name: 'admin-student-detail',
        path: 'students/:id',
        component: () => import('../pages/admin/DetailStudent.vue'),
      },
      {
        name: 'admin-policy-management',
        path: 'policy',
        component: () => import('../pages/admin/Policy.vue'),
      },
      {
        name: 'admin-teacher-detail',
        path: 'teachers/:id',
        component: () => import('../pages/admin/DetailTeacher.vue'),
      },

      // ===== LMS（管理者導線） =====
      {
        name: 'admin-lms-courses',
        path: 'lms/courses',
        component: () => import('../pages/admin/lms/CoursesAdmin.vue'),
      },
      {
        // コース管理詳細は講師と共用（prefix-aware）
        name: 'admin-lms-course',
        path: 'lms/courses/:courseId',
        component: () => import('../pages/teacher/lms/CourseManage.vue'),
      },
      {
        name: 'admin-lms-quiz-new',
        path: 'lms/courses/:courseId/quizzes/new',
        component: () => import('../pages/teacher/lms/QuizEdit.vue'),
      },
      {
        name: 'admin-lms-quiz-edit',
        path: 'lms/quizzes/:quizId/edit',
        component: () => import('../pages/teacher/lms/QuizEdit.vue'),
      },
      {
        // 旧「受講登録」ページは「生徒LMS管理」に統合。旧URLは新ページへリダイレクト。
        // （Enrollments.vue ファイルは切り戻し用に残置）
        name: 'admin-lms-enrollments',
        path: 'lms/enrollments',
        redirect: { name: 'admin-lms-users' },
      },
      {
        name: 'admin-lms-users',
        path: 'lms/users',
        component: () => import('../pages/admin/lms/UsersAdmin.vue'),
      },
      {
        // 全コース横断のクイズ管理
        name: 'admin-lms-all-quizzes',
        path: 'lms/quizzes',
        component: () => import('../pages/admin/lms/QuizzesAdmin.vue'),
      },
      {
        // 全コース横断の教材管理
        name: 'admin-lms-all-materials',
        path: 'lms/materials',
        component: () => import('../pages/admin/lms/MaterialsAdmin.vue'),
      },
      {
        name: 'admin-lms-teachers',
        path: 'lms/teachers',
        component: () => import('../pages/admin/lms/Teachers.vue'),
      },
      {
        // 成績閲覧は講師と共用（admin は全生徒）
        name: 'admin-lms-students',
        path: 'lms/students',
        component: () => import('../pages/teacher/lms/Students.vue'),
      },
      {
        name: 'admin-lms-feedback',
        path: 'lms/feedback',
        component: () => import('../pages/admin/lms/FeedbackAdmin.vue'),
      },
      {
        // 【フェーズ0・完全隔離モック】LMSメッセージ機能のサンプル画面。
        // サイドバー(AdminLayout.vue)には出さず、直URL /admin/lms/messages でのみ到達。
        // API未使用・完全モック。既存ページの挙動は変更しない（新ページ登録のみ）。
        name: 'admin-lms-messages',
        path: 'lms/messages',
        component: () => import('../pages/admin/lms/MessagesAdmin.vue'),
      },

      // ===== 採用試験（管理者導線・追加のみ） =====
      {
        name: 'admin-recruit-applicants',
        path: 'recruit/applicants',
        component: () => import('../pages/admin/recruit/Applicants.vue'),
      },
      {
        name: 'admin-recruit-applicant-detail',
        path: 'recruit/applicants/:id',
        component: () => import('../pages/admin/recruit/ApplicantDetail.vue'),
      },
      {
        name: 'admin-recruit-attempts',
        path: 'recruit/attempts',
        component: () => import('../pages/admin/recruit/Attempts.vue'),
      },
      {
        name: 'admin-recruit-attempt-grading',
        path: 'recruit/attempts/:id',
        component: () => import('../pages/admin/recruit/AttemptGrading.vue'),
      },
      {
        name: 'admin-recruit-exam-editor',
        path: 'recruit/exam',
        component: () => import('../pages/admin/recruit/ExamEditor.vue'),
      },
    ],
  },
  {
    path: '/teacher',
    component: () => import('../layouts/TeacherLayout.vue'),
    children: [
      {
        name: 'teacher-list-student',
        path: 'students',
        component: () => import('../pages/teacher/ListStudent.vue'),
      },
      {
        name: 'teacher-my-page',
        path: 'me',
        component: () => import('../pages/teacher/MyPage.vue'),
      },
      {
        name: 'teacher-detail-student',
        path: 'students/:id',
        component: () => import('../pages/teacher/DetailStudent.vue'),
      },

      // ===== LMS（講師導線） =====
      {
        name: 'teacher-lms-courses',
        path: 'lms/courses',
        component: () => import('../pages/teacher/lms/Courses.vue'),
      },
      {
        name: 'teacher-lms-course',
        path: 'lms/courses/:courseId',
        component: () => import('../pages/teacher/lms/CourseManage.vue'),
      },
      {
        name: 'teacher-lms-quiz-new',
        path: 'lms/courses/:courseId/quizzes/new',
        component: () => import('../pages/teacher/lms/QuizEdit.vue'),
      },
      {
        name: 'teacher-lms-quiz-edit',
        path: 'lms/quizzes/:quizId/edit',
        component: () => import('../pages/teacher/lms/QuizEdit.vue'),
      },
      {
        name: 'teacher-lms-students',
        path: 'lms/students',
        component: () => import('../pages/teacher/lms/Students.vue'),
      },
      {
        name: 'teacher-lms-feedback',
        path: 'lms/feedback',
        component: () => import('../pages/teacher/lms/Feedback.vue'),
      },
      {
        name: 'teacher-lms-manual',
        path: 'lms/manual',
        component: () => import('../pages/teacher/lms/Manual.vue'),
      },
    ],
  },

  {
    name: 'teacher-signup',
    path: '/teacher/signup',
    component: () => import('../pages/auth/TeacherSignup.vue'),
  },
  {
    name: 'forgot-password',
    path: '/forgot-password',
    component: () => import('../pages/auth/ForgotPassword.vue'),
  },
  {
    name: 'reset-password',
    path: '/reset-password',
    component: () => import('../pages/auth/ResetPassword.vue'),
  }
]

export default routes
